var _ellipse, _path, _rect, _ellipse2, _path2, _path3, _rect2, _rect3, _path4, _path5, _rect4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.4898,
    cy: 24,
    rx: 24.4898,
    ry: 24,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.1271C20 12.5942 21.2427 11.3516 22.7756 11.3516H26.4009C27.9338 11.3516 29.1765 12.5942 29.1765 14.1271H20Z",
    fill: "url(#paint0_linear_3930_8460)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.4004,
    y: 8.21484,
    width: 0.628525,
    height: 3.37895,
    fill: "url(#paint1_linear_3930_8460)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.7144,
    cy: 7.18898,
    rx: 1.3199,
    ry: 1.26711,
    fill: "url(#paint2_linear_3930_8460)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4876 36.6416C11.4952 36.633 9.16598 32.4794 8.5 30.4016C7.66667 30.4016 6 30.0176 6 28.4816V23.2016C6.16609 22.5638 7.09357 21.3858 9.47521 21.7577C10.7318 17.7456 14.7172 13.1661 24.4991 13.5765C34.2784 13.1677 38.2627 17.747 39.5188 21.7586C41.9049 21.3838 42.8338 22.5633 43 23.2016V28.4816C43 30.0176 41.3333 30.4016 40.5 30.4016C39.8333 32.4816 37.5 36.6416 33.5 36.6416H15.4876Z",
    fill: "url(#paint3_linear_3930_8460)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 36.6416H15.5C11.5 36.6416 9.16667 32.4816 8.5 30.4016C7.66667 30.4016 6 30.0176 6 28.4816V23.2016C6.16667 22.5616 7.1 21.3776 9.5 21.7616M15 36.6416H33.5C37.5 36.6416 39.8333 32.4816 40.5 30.4016C41.3333 30.4016 43 30.0176 43 28.4816V23.2016C42.8333 22.5616 41.9 21.3776 39.5 21.7616M9.00031 25.1214C8.83365 20.9614 11.8 12.8336 25 13.6016M39.9935 25.1216C40.1601 20.9616 37.1938 12.8338 23.9938 13.6018",
    stroke: "url(#paint4_linear_3930_8460)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 19.3594,
    width: 23,
    height: 11.52,
    rx: 5.76,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 19.3594,
    width: 23,
    height: 11.52,
    rx: 5.76,
    stroke: "url(#paint5_linear_3930_8460)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25.6002C32 26.3954 31.3284 27.0402 30.5 27.0402C29.6716 27.0402 29 26.3954 29 25.6002C29 24.8049 29.6716 24.1602 30.5 24.1602C31.3284 24.1602 32 24.8049 32 25.6002Z",
    fill: "url(#paint6_linear_3930_8460)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.6002C20 26.3954 19.3284 27.0402 18.5 27.0402C17.6716 27.0402 17 26.3954 17 25.6002C17 24.8049 17.6716 24.1602 18.5 24.1602C19.3284 24.1602 20 24.8049 20 25.6002Z",
    fill: "url(#paint7_linear_3930_8460)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 34,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#EE4352",
    fillOpacity: 0.969
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3930_8460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 34C40.6155 34 39.2622 34.4105 38.111 35.1797C36.9599 35.9489 36.0627 37.0421 35.5328 38.3212C35.003 39.6003 34.8644 41.0078 35.1345 42.3656C35.4046 43.7235 36.0713 44.9708 37.0503 45.9497C38.0292 46.9287 39.2765 47.5954 40.6344 47.8655C41.9922 48.1356 43.3997 47.997 44.6788 47.4672C45.9579 46.9373 47.0511 46.0401 47.8203 44.889C48.5895 43.7378 49 42.3845 49 41C48.998 39.1441 48.2599 37.3648 46.9475 36.0525C45.6352 34.7401 43.8559 34.002 42 34V34ZM42 46.8333C40.8463 46.8333 39.7185 46.4912 38.7592 45.8502C37.7999 45.2093 37.0522 44.2982 36.6107 43.2323C36.1692 42.1664 36.0537 40.9935 36.2788 39.862C36.5038 38.7304 37.0594 37.691 37.8752 36.8752C38.691 36.0594 39.7304 35.5038 40.862 35.2788C41.9935 35.0537 43.1664 35.1692 44.2323 35.6107C45.2982 36.0522 46.2093 36.7999 46.8502 37.7592C47.4912 38.7185 47.8333 39.8463 47.8333 41C47.8316 42.5466 47.2165 44.0293 46.1229 45.1229C45.0293 46.2165 43.5466 46.8316 42 46.8333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9994 36.918C41.8446 36.918 41.6963 36.9794 41.5869 37.0888C41.4775 37.1982 41.416 37.3466 41.416 37.5013V42.168C41.416 42.3227 41.4775 42.4711 41.5869 42.5804C41.6963 42.6898 41.8446 42.7513 41.9994 42.7513C42.1541 42.7513 42.3024 42.6898 42.4118 42.5804C42.5212 42.4711 42.5827 42.3227 42.5827 42.168V37.5013C42.5827 37.3466 42.5212 37.1982 42.4118 37.0888C42.3024 36.9794 42.1541 36.918 41.9994 36.918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5827 44.5013C42.5827 44.1791 42.3215 43.918 41.9994 43.918C41.6772 43.918 41.416 44.1791 41.416 44.5013C41.416 44.8235 41.6772 45.0846 41.9994 45.0846C42.3215 45.0846 42.5827 44.8235 42.5827 44.5013Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3930_8460",
    x1: 18.5,
    y1: 12.9751,
    x2: 20.4323,
    y2: 16.4429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3930_8460",
    x1: 24.2977,
    y1: 10.1913,
    x2: 24.8506,
    y2: 10.2472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3930_8460",
    x1: 22.963,
    y1: 7.40425,
    x2: 24.7408,
    y2: 8.40945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3930_8460",
    x1: -0.0480771,
    y1: 27.0576,
    x2: 18.673,
    y2: 43.3409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3930_8460",
    x1: -0.0480771,
    y1: 27.0576,
    x2: 18.673,
    y2: 43.3409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3930_8460",
    x1: 9.24038,
    y1: 26.0979,
    x2: 18.641,
    y2: 36.2857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3930_8460",
    x1: 28.5096,
    y1: 25.8448,
    x2: 30.53,
    y2: 26.9872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3930_8460",
    x1: 16.5096,
    y1: 25.8448,
    x2: 18.53,
    y2: 26.9872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3930_8460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(35 34)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMsg);
export default __webpack_public_path__ + "static/media/ErrorMsg.7172b0c9.svg";
export { ForwardRef as ReactComponent };